import { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Badges";
import { StatTile, TrainingItemRow } from "@/components/training/TrainingBits";

const FILTERS = {
  todo: (i) => i.status !== "completed",
  in_progress: (i) => i.status === "in_progress",
  overdue: (i) => i.overdue,
  completed: (i) => i.status === "completed",
};

export default function MyTraining() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("todo");

  useEffect(() => {
    api.get("/me/training").then((r) => setData(r.data));
  }, []);

  if (!data) return null;
  const s = data.summary;
  const items = data.items.filter(FILTERS[tab]);

  return (
    <div className="fade-up">
      <PageHeader eyebrow="My Training" title="Your assigned training" description="Courses and SOP acknowledgments assigned to you, your role, community or region." />
      <div className="mb-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
        <StatTile label="Assigned" value={s.assigned} testId="my-training-stat-assigned" />
        <StatTile label="Completed" value={s.completed} testId="my-training-stat-completed" />
        <StatTile label="Overdue" value={s.overdue} tone="danger" testId="my-training-stat-overdue" />
        <StatTile label="Certificates" value={s.certificates} testId="my-training-stat-certificates" />
      </div>
      <Tabs value={tab} onValueChange={setTab} className="mb-6">
        <TabsList data-testid="my-training-tabs">
          <TabsTrigger value="todo" data-testid="my-training-tab-todo">To do ({data.items.filter(FILTERS.todo).length})</TabsTrigger>
          <TabsTrigger value="in_progress" data-testid="my-training-tab-in-progress">In progress ({s.in_progress})</TabsTrigger>
          <TabsTrigger value="overdue" data-testid="my-training-tab-overdue">Overdue ({s.overdue})</TabsTrigger>
          <TabsTrigger value="completed" data-testid="my-training-tab-completed">Completed ({s.completed})</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="space-y-3" data-testid="my-training-list">
        {items.length === 0 && <EmptyState title="Nothing here" description="You're all caught up in this view." testId="my-training-empty" />}
        {items.map((i) => <TrainingItemRow key={`${i.item_type}-${i.item_id}`} item={i} />)}
      </div>
      {data.self_enrolled.length > 0 && (
        <section className="mt-12">
          <h2 className="mb-4 font-display text-sm font-bold uppercase tracking-[0.14em]">Other courses you've started</h2>
          <div className="space-y-3">{data.self_enrolled.map((i) => <TrainingItemRow key={i.item_id} item={i} />)}</div>
        </section>
      )}
    </div>
  );
}
